import React, { useEffect } from 'react';
import { ZoomIn, Camera } from 'lucide-react';
import gallery1 from '../assets/gallery/about6.jpg';
import gallery2 from '../assets/gallery/office.jpg';
import about1 from '../assets/aboutpage_images/about1.jpg';
import about2 from '../assets/aboutpage_images/about2.jpg';
import about3 from '../assets/aboutpage_images/about3.jpg';
import about4 from '../assets/aboutpage_images/about4.jpg';
import about5 from '../assets/aboutpage_images/about5.jpg';
import about6 from '../assets/aboutpage_images/about6.jpg';
import about7 from '../assets/aboutpage_images/about7.jpg';
import about8 from '../assets/aboutpage_images/about8.jpg';
import about9 from '../assets/aboutpage_images/about9.jpg';
import about10 from '../assets/aboutpage_images/about10.jpg';
import about11 from '../assets/aboutpage_images/about11.jpg';
import about12 from '../assets/aboutpage_images/about12.jpg';


const Gallery = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const images = [
    { src: about1, alt: 'Therapy Session 1', category: 'Therapy' },
    { src: about2, alt: 'Play Area', category: 'Facilities' },
    { src: about3, alt: 'Therapy Session 2', category: 'Therapy' },
    { src: about4, alt: 'Sensory Room', category: 'Facilities' },
    { src: about5, alt: 'Group Activity', category: 'Activities' },
    { src: about6, alt: 'Therapy Activities', category: 'Activities' },
    { src: about7, alt: 'Therapy Session 3', category: 'Therapy' },
    { src: about8, alt: 'Learning Space', category: 'Facilities' },
    { src: about9, alt: 'Child Development Session', category: 'Therapy' },
    { src: about10, alt: 'Interactive Session', category: 'Activities' },
    { src: about11, alt: 'Play Therapy', category: 'Therapy' },
    { src: about12, alt: 'Care Center Moments', category: 'Facilities' },
    { src: gallery2, alt: 'Office Reception', category: 'Facilities' },
    { src: gallery1, alt: 'Staff Members', category: 'Team' },
  ];

  return (
    <div className="font-sans text-[#424242] bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="bg-indigo-700 py-20 px-5 text-center text-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-indigo-900/50 to-violet-900/50"></div>
        <div className="absolute -bottom-10 -right-10 text-white/5 rotate-12">
          <Camera size={300} strokeWidth={1} />
        </div>
        <div className="relative z-10 max-w-[800px] mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-4 ">Our Gallery</h1>
          <p className="text-xl text-indigo-100 font-light">
            A glimpse into our world of care, compassion, and progress.
          </p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div key={index} className="relative group rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 bg-white h-64 md:h-72 lg:h-80">
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-md p-2 rounded-full text-white transform scale-0 group-hover:scale-100 transition-transform duration-300 delay-150">
                  <ZoomIn size={20} />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-20 mb-8">
          <div className="w-24 h-1 bg-indigo-100 mx-auto mb-6 rounded-full"></div>
          <p className="text-2xl md:text-3xl text-indigo-900/80 leading-relaxed">"Every picture tells a story of hope and healing."</p>
        </div>
      </div>
    </div>
  );
};

export default Gallery;

